export const SAVE_BOOKING = "SAVE_BOOKING";
export const SAVE_BOOKING_SUCCESS = "SAVE_BOOKING_SUCCESS";
export const SAVE_BOOKING_FAILED = "SAVE_BOOKING_FAILED";
export const SAVE_RESERVATION = "SAVE_RESERVATION";
export const SAVE_RESERVATION_SUCCESS = "SAVE_RESERVATION_SUCCESS";
export const SAVE_RESERVATION_FAILED = "SAVE_RESERVATION_FAILED";
export const FETCH_BOOKINGS = "FETCH_BOOKINGS";
export const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
export const FETCH_BOOKINGS_FAILED = "FETCH_BOOKINGS_FAILED";
export const GET_BOOKINGS = "GET_BOOKINGS";
export const GET_BOOKINGS_SUCCESS = "GET_BOOKINGS_SUCCESS";
export const GET_BOOKINGS_FAILED = "GET_BOOKINGS_FAILED";
export const GET_RESERVATIONS_STATUS = "GET_RESERVATIONS_STATUS";
export const GET_RESERVATIONS_STATUS_SUCCESS = "GET_RESERVATIONS_STATUS_SUCCESS";
export const GET_RESERVATIONS_STATUS_FAILED = "GET_RESERVATIONS_STATUS_FAILED";
export const GET_RESERVATIONS_FEEDBACK = "GET_RESERVATIONS_FEEDBACK";
export const GET_RESERVATIONS_FEEDBACK_SUCCESS = "GET_RESERVATIONS_FEEDBACK_SUCCESS";
export const GET_RESERVATIONS_FEEDBACK_FAILED = "GET_RESERVATIONS_FEEDBACK_FAILED";
export const UPLOAD_BOOKING_IMAGE = "UPLOAD_BOOKING_IMAGE";
export const UPLOAD_BOOKING_IMAGE_SUCCESS = "UPLOAD_BOOKING_IMAGE_SUCCESS";
export const UPLOAD_BOOKING_IMAGE_FAILED = "UPLOAD_BOOKING_IMAGE_FAILED";
export const DELETE_BOOKING_IMAGE = "DELETE_BOOKING_IMAGE";
export const DELETE_BOOKING_IMAGE_SUCCESS = "DELETE_BOOKING_IMAGE_SUCCESS";
export const DELETE_BOOKING_IMAGE_FAILED = "DELETE_BOOKING_IMAGE_FAILED";
export const RESCHEDULE = "RESCHEDULE";
export const RESCHEDULE_SUCCESS = "RESCHEDULE_SUCCESS";
export const RESCHEDULE_FAILED = "RESCHEDULE_FAILED";
export const DELETE_BOOKING_TRANSACTION = "DELETE_BOOKING_TRANSACTION";
export const DELETE_BOOKING_TRANSACTION_SUCCESS = "DELETE_BOOKING_TRANSACTION_SUCCESS";
export const DELETE_BOOKING_TRANSACTION_FAILED = "DELETE_BOOKING_TRANSACTION_FAILED";
export const GET_BOOKING_EVENTS = "GET_BOOKING_EVENTS";
export const GET_BOOKING_EVENTS_SUCCESS = "GET_BOOKING_EVENTS_SUCCESS";
export const GET_BOOKING_EVENTS_FAILED = "GET_BOOKING_EVENTS_FAILED";
export const GET_WORKSHOP_IMAGES = "GET_WORKSHOP_IMAGES";
export const GET_WORKSHOP_IMAGES_SUCCESS = "GET_WORKSHOP_IMAGES_SUCCESS";
export const GET_WORKSHOP_IMAGES_FAILED = "GET_WORKSHOP_IMAGES_FAILED";
export const SAVE_PREBOOK_IMAGE = "SAVE_PREBOOK_IMAGE";
export const SAVE_PREBOOK_IMAGE_SUCCESS = "SAVE_PREBOOK_IMAGE_SUCCESS";
export const SAVE_PREBOOK_IMAGE_FAILED = "SAVE_PREBOOK_IMAGE_FAILED";

// export const SAVE_VEHICLE_BOOKING_IMAGE = "SAVE_VEHICLE_BOOKING_IMAGE";
// export const SAVE_VEHICLE_BOOKING_IMAGE_SUCCESS = "SAVE_VEHICLE_BOOKING_IMAGE_SUCCESS";
// export const SAVE_VEHICLE_BOOKING_IMAGE_FAILED = "SAVE_VEHICLE_BOOKING_IMAGE_FAILED";

export const DELETE_PREBOOK_IMAGE = "DELETE_PREBOOK_IMAGE";
export const DELETE_PREBOOK_IMAGE_SUCCESS = "DELETE_PREBOOK_IMAGE_SUCCESS";
export const DELETE_PREBOOK_IMAGE_FAILED = "DELETE_PREBOOK_IMAGE_FAILED";
export const FETCH_FEEDBACK_QUESTIONS = "FETCH_FEEDBACK_QUESTIONS";
export const FETCH_FEEDBACK_QUESTIONS_SUCCESS = "FETCH_FEEDBACK_QUESTIONS_SUCCESS";
export const FETCH_FEEDBACK_QUESTIONS_FAILED = "FETCH_FEEDBACK_QUESTIONS_FAILED";
export const SAVE_FEEDBACK = "SAVE_FEEDBACK";
export const SAVE_FEEDBACK_SUCCESS = "SAVE_FEEDBACK_SUCCESS";
export const SAVE_FEEDBACK_FAILED = "SAVE_FEEDBACK_FAILED";
export const CALL_BACK_RAZORPAY = "CALL_BACK_RAZORPAY";
export const CALL_BACK_RAZORPAY_SUCCESS = "CALL_BACK_RAZORPAY_SUCCESS";
export const CALL_BACK_RAZORPAY_FAILED = "CALL_BACK_RAZORPAY_FAILED";

export const GET_BOOKING_SUMMARY = "GET_BOOKING_SUMMARY";
export const GET_BOOKING_SUMMARY_SUCCESS = "GET_BOOKING_SUMMARY_SUCCESS";
export const GET_BOOKING_SUMMARY_FAILED = "GET_BOOKING_SUMMARY_FAILED";

export const UPDATE_BOOKING_SUMMARY = "UPDATE_BOOKING_SUMMARY";
export const SAVE_BOOKING_DET_HEADER_STATUS = "SAVE_BOOKING_DET_HEADER_STATUS";

export const CLEAR_PARTICULAR_BOOKING = "CLEAR_PARTICULAR_BOOKING";
export const GET_ADVANCE_ORDERID = "GET_ADVANCE_ORDERID";
export const GET_ADVANCE_ORDERID_SUCCESS = "GET_ADVANCE_ORDERID_SUCCESS";
export const GET_ADVANCE_ORDERID_FAILED = "GET_ADVANCE_ORDERID_FAILED";

export const GET_FEEDBACK = "GET_FEEDBACK";
export const GET_FEEDBACK_SUCCESS = "GET_FEEDBACK_SUCCESS";
export const GET_FEEDBACK_FAILED = "GET_FEEDBACK_FAILED";
export const UPDATE_PARTICULAR_BOOKING_DETAILS = "UPDATE_PARTICULAR_BOOKING_DETAILS";
export const UPDATE_RESERVATION_PARTICULAR_BOOKING_DETAILS =
  "UPDATE_RESERVATION_PARTICULAR_BOOKING_DETAILS";

export const CLEAR_BOOKING_IMAGES = "CLEAR_BOOKING_IMAGES";
export const CLEAR_SAVED_FEEDBACK_STATUS = "CLEAR_SAVED_FEEDBACK_STATUS";
